import BlogHome1 from "../components/blog/BlogHome1";
import Populares from "../components/blog/Populares";
import BlogSlider from "../components/blog/slider";
import LatestArticlesCarousel from "../components/blog/LatestArticlesCarousel";
import { blogArticles } from "../data/blogContent";

const Blog = () => {
  const latestArticles = blogArticles
    .slice()
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
    .slice(0, 9);

  return (
    <div className="bg-white">
      <BlogHome1 />
      <LatestArticlesCarousel articles={latestArticles} />
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Populares />
      </div>
      <BlogSlider />
    </div>
  );
};

export default Blog;
